import React from 'react';
import clsx from 'clsx';
import { Background } from '~/common/components';
import { Container } from '@wyz/ui';

type BackgroundProps = React.ComponentProps<typeof Background>;
interface SectionProps {
  fluid?: boolean;
  bg?: string;
  image?: BackgroundProps['image'];
  overlay?: boolean | string;
  position?:
    | string
    | {
        x?: string;
        y?: string;
      };
  video?: BackgroundProps['video'];
  bgClassName?: string;
  className?: string;
  children?: React.ReactNode;
}

const Section = ({
  fluid = false,
  bg,
  image,
  overlay,
  position,
  video,
  bgClassName,
  className,
  children,
  ...rest
}: SectionProps) => {
  return (
    <section
      className={clsx({ [`bg-${bg as string}`]: bg }, className)}
      {...rest}
    >
      {image && (
        <Background
          {...{
            image,
            overlay,
            position,
            video,
            className: bgClassName,
          }}
        />
      )}
      <Container fluid={fluid}>{children}</Container>
    </section>
  );
};

export default Section;
